import { getUserInfo } from '@/utils/auth';

export default {
  methods: {
    __action(key) {
      const { permissions } = getUserInfo();
      return permissions && permissions.indexOf(key) >= 0;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/index.js